// extracted by mini-css-extract-plugin
module.exports = {"cals":"HeatLoadCalculationContainer_cals__1ALil"};